<template>
  <div v-if="label" class="app-deployment-badge text-warning me-2 me-3 mr-3">
    <div
      class="spinner-grow spinner-grow-sm"
      role="status"
      aria-hidden="true"
    />
    {{ label }}
  </div>
</template>

<script setup lang="ts">
/**
 * Deployment marker for the top navbar, e.g. "Acceptance Server".
 *
 * The label is resolved by settingsStore.deploymentLabel and is empty when the
 * app runs on a deployment without a marker, so nothing is rendered at all.
 * App.vue teleports this component into nav.navbar; the styling therefore lives
 * in src/styles/app-overrides.css instead of a scoped block.
 */
defineProps<{ label: string }>();
</script>
